<template>
  <div v-if="podeConsultarLemit" class="client-feature-block mb-4">
    <div class="d-flex align-center justify-space-between mb-2">
      <div class="subtitle-1 font-weight-medium d-flex align-center flex-wrap">
        <v-icon left small color="primary">mdi-account-search-outline</v-icon>
          Informações do contato
        <v-chip
          x-small
          color="amber darken-2"
          text-color="white"
          class="ml-2 feature-novo-chip"
        >
          <v-icon left x-small>mdi-star-four-points</v-icon>
          Novo
        </v-chip>
      </div>
      <v-btn
        small
        color="primary"
        class="feature-action-btn white--text font-weight-bold"
        elevation="2"
        :loading="consultandoLemit"
        :disabled="!cpfLimpo || cpfLimpo.length !== 11"
        @click="abrirConfirmacaoEnriquecimento"
      >
        <v-icon left small>mdi-database-search</v-icon>
        Enriquecimento
      </v-btn>
    </div>

    <v-divider class="mb-3"></v-divider>

    <div class="caption grey--text">
      Consulta complementar pelo CPF do cliente (centro de custo SAC).
    </div>

    <v-divider class="mt-3"></v-divider>

    <v-dialog v-model="dialogConfirmacao" persistent max-width="480">
      <v-card>
        <v-card-title>Enriquecimento Lemit</v-card-title>
        <v-card-text>
          Deseja consultar o enriquecimento deste cliente na Lemit?
          A consulta pode consumir crédito do centro de custo SAC.
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn color="grey darken-1" text @click="dialogConfirmacao = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="consultandoLemit"
            @click="confirmarEnriquecimento"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLemitDialog" max-width="900" scrollable>
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left>mdi-account-search</v-icon>
          Enriquecimento
        </v-card-title>

        <v-card-text class="pt-4">
          <div v-if="consultandoLemit" class="text-center py-8">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-3">Consultando Lemit...</div>
          </div>

          <v-alert v-else-if="lemitError" type="error" dense text>
            {{ lemitError }}
          </v-alert>

          <template v-else-if="consultaLemit">
            <div class="d-flex flex-wrap align-center mb-3">
              <v-chip
                small
                class="mr-2 mb-2"
                :color="consultaLemit.origem === 'CACHE' ? 'orange' : 'green'"
                text-color="white"
              >
                {{ consultaLemit.origem === 'CACHE' ? 'CACHE' : 'API' }}
              </v-chip>

              <v-chip
                v-if="lemitPessoa && lemitPessoa.falecido"
                small
                class="mr-2 mb-2"
                color="error"
                text-color="white"
              >
                FALECIDO
              </v-chip>

              <v-chip
                v-if="lemitPessoa && lemitPessoa.situacao_cpf"
                small
                class="mr-2 mb-2"
                color="blue-grey"
                text-color="white"
              >
                {{ lemitPessoa.situacao_cpf }}
              </v-chip>

              <span class="grey--text text--darken-1 caption mb-2">
                Consulta #{{ consultaLemit.idConsulta }}
                <span v-if="consultaLemit.dataConsulta">
                  · {{ consultaLemit.dataConsulta }}
                </span>
                <span v-if="consultaLemit.nomeUsuario">
                  · {{ consultaLemit.nomeUsuario }}
                </span>
              </span>
            </div>

            <v-alert
              v-if="consultaEhDiaAnterior"
              type="warning"
              dense
              text
              class="mb-3"
            >
              Esta consulta é anterior, feita no dia {{ dataConsultaLemitExibicao }}.
            </v-alert>

            <v-alert
              v-else-if="consultaLemit.origem === 'CACHE'"
              type="info"
              dense
              text
              class="mb-3"
            >
              Dados reutilizados de consulta anterior (sem nova cobrança).
              <span v-if="consultaLemit.dataConsultaLemit">
                Consulta Lemit realizada em {{ consultaLemit.dataConsultaLemit }}.
              </span>
            </v-alert>

            <v-alert
              v-if="consultaLemit.sucesso === false"
              type="error"
              dense
              text
              class="mb-3"
            >
              {{ consultaLemit.mensagemErro || 'Consulta não retornou dados.' }}
            </v-alert>

            <template v-if="lemitPessoa">
              <div class="section-title">Dados pessoais</div>
              <v-simple-table dense class="elevation-0 mb-4">
                <tbody>
                  <tr>
                    <td class="label-cell">Nome</td>
                    <td>{{ lemitPessoa.nome || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="label-cell">CPF</td>
                    <td>{{ formatarCpfExibicao(lemitPessoa.cpf || consultaLemit.cpf) }}</td>
                  </tr>
                  <tr>
                    <td class="label-cell">Nascimento</td>
                    <td>{{ formatarDataIso(lemitPessoa.data_nascimento) }}</td>
                  </tr>
                  <tr>
                    <td class="label-cell">Sexo</td>
                    <td>{{ lemitPessoa.sexo || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="label-cell">Nome da mãe</td>
                    <td>{{ lemitPessoa.nome_mae || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="label-cell">Ocupação</td>
                    <td>{{ lemitPessoa.ocupacao || '—' }}</td>
                  </tr>
                  <tr v-if="lemitPessoa.risco_credito && lemitPessoa.risco_credito.score_credito">
                    <td class="label-cell">Score crédito</td>
                    <td>{{ lemitPessoa.risco_credito.score_credito }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="section-title">Celulares</div>
              <v-data-table
                :headers="headersCelulares"
                :items="listaOrdenada(lemitPessoa.celulares)"
                :items-per-page="5"
                dense
                class="elevation-0 mb-4"
                hide-default-footer
              >
                <template v-slot:item.numero="{ item }">
                  ({{ item.ddd }}) {{ item.numero }}
                </template>
                <template v-slot:item.whatsapp="{ item }">
                  <v-icon v-if="item.whatsapp" small color="green">mdi-whatsapp</v-icon>
                  <span v-else class="grey--text">—</span>
                </template>
                <template v-slot:no-data>
                  <div class="text-center py-3">Nenhum celular</div>
                </template>
              </v-data-table>

              <div class="section-title">E-mails</div>
              <v-data-table
                :headers="headersEmails"
                :items="listaOrdenada(lemitPessoa.emails)"
                :items-per-page="5"
                dense
                class="elevation-0 mb-4"
                hide-default-footer
              >
                <template v-slot:no-data>
                  <div class="text-center py-3">Nenhum e-mail</div>
                </template>
              </v-data-table>

              <div class="section-title">Endereços</div>
              <v-data-table
                :headers="headersEnderecos"
                :items="listaOrdenada(lemitPessoa.enderecos)"
                :items-per-page="5"
                dense
                class="elevation-0 mb-2"
              >
                <template v-slot:item.cep="{ item }">
                  {{ formatarCep(item.cep) }}
                </template>
                <template v-slot:no-data>
                  <div class="text-center py-3">Nenhum endereço</div>
                </template>
              </v-data-table>
            </template>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showLemitDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LemitService from '@/services/lemit'

export default {
  name: 'ClienteLemitExtraBlock',

  props: {
    clientInfo: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      consultandoLemit: false,
      dialogConfirmacao: false,
      showLemitDialog: false,
      consultaLemit: null,
      lemitError: null,
      headersCelulares: [
        { text: 'Ranking', value: 'ranking', width: '90px' },
        { text: 'Número', value: 'numero' },
        { text: 'WhatsApp', value: 'whatsapp', width: '100px' },
      ],
      headersEmails: [
        { text: 'Ranking', value: 'ranking', width: '90px' },
        { text: 'E-mail', value: 'email' },
      ],
      headersEnderecos: [
        { text: 'Ranking', value: 'ranking', width: '90px' },
        { text: 'Endereço', value: 'endereco' },
        { text: 'Bairro', value: 'bairro' },
        { text: 'Cidade', value: 'cidade' },
        { text: 'UF', value: 'uf', width: '60px' },
        { text: 'CEP', value: 'cep', width: '110px' },
        { text: 'Tipo', value: 'tipo', width: '110px' },
      ],
    }
  },

  computed: {
    userRoles() {
      try {
        const user = JSON.parse(sessionStorage.getItem('user') || '{}')
        return Array.isArray(user.roles) ? user.roles : []
      } catch (error) {
        return []
      }
    },

    podeConsultarLemit() {
      return (
        this.userRoles.includes('ROLE_ADMIN') ||
        this.userRoles.includes('ROLE_LEMIT_CONSULTA_CHAT')
      )
    },

    cpfLimpo() {
      return String(this.clientInfo?.cpf || '').replace(/\D/g, '')
    },

    lemitPessoa() {
      return this.consultaLemit?.dados?.pessoa || null
    },

    dataConsultaLemitReferencia() {
      return this.obterDataConsultaLemit(this.consultaLemit)
    },

    consultaEhDiaAnterior() {
      return this.isDiaAnterior(this.dataConsultaLemitReferencia)
    },

    dataConsultaLemitExibicao() {
      if (!this.dataConsultaLemitReferencia) return ''
      return this.dataConsultaLemitReferencia.toLocaleDateString('pt-BR')
    },
  },

  watch: {
    clientInfo() {
      this.limparConsulta()
    },
  },

  methods: {
    limparConsulta() {
      this.consultaLemit = null
      this.lemitError = null
      this.dialogConfirmacao = false
      this.showLemitDialog = false
    },

    extrairMensagemErro(error) {
      const data = error?.response?.data
      if (!data) return 'Não foi possível consultar a Lemit.'
      if (typeof data === 'string') return data
      return (
        data.mensagem ||
        data.mensagemErro ||
        data.message ||
        'Não foi possível consultar a Lemit.'
      )
    },

    abrirConfirmacaoEnriquecimento() {
      if (!this.podeConsultarLemit) return

      if (!this.cpfLimpo || this.cpfLimpo.length !== 11) {
        this.lemitError = 'CPF do cliente não disponível para consulta.'
        this.showLemitDialog = true
        return
      }

      this.dialogConfirmacao = true
    },

    async confirmarEnriquecimento() {
      this.dialogConfirmacao = false
      await this.consultarLemitExtra()
    },

    async consultarLemitExtra() {
      if (!this.podeConsultarLemit) return

      if (!this.cpfLimpo || this.cpfLimpo.length !== 11) {
        this.lemitError = 'CPF do cliente não disponível para consulta.'
        this.showLemitDialog = true
        return
      }

      this.showLemitDialog = true
      this.consultandoLemit = true
      this.consultaLemit = null
      this.lemitError = null

      try {
        const response = await LemitService.consultarPessoa(
          this.cpfLimpo,
          'sac',
          false,
        )
        this.consultaLemit = response.data || null
      } catch (error) {
        console.error('Erro ao consultar Lemit no chat:', error)
        this.lemitError = this.extrairMensagemErro(error)
      } finally {
        this.consultandoLemit = false
      }
    },

    formatarCpfExibicao(cpf) {
      const digits = String(cpf || '').replace(/\D/g, '')
      if (digits.length !== 11) return cpf || '—'
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`
    },

    formatarCep(cep) {
      const digits = String(cep || '').replace(/\D/g, '')
      if (digits.length !== 8) return cep || '—'
      return `${digits.slice(0, 5)}-${digits.slice(5)}`
    },

    formatarDataIso(value) {
      if (!value) return '—'
      const data = new Date(value)
      if (Number.isNaN(data.getTime())) return value
      return data.toLocaleDateString('pt-BR')
    },

    formatarMoeda(valor) {
      if (valor === null || valor === undefined || valor === '') return '—'
      const numero = Number(valor)
      if (Number.isNaN(numero)) return String(valor)
      return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },

    listaOrdenada(lista) {
      if (!Array.isArray(lista)) return []
      return [...lista].sort((a, b) => (a.ranking || 999) - (b.ranking || 999))
    },

    obterDataConsultaLemit(consulta) {
      if (!consulta) return null
      return (
        this.parseDataLemit(consulta.dataConsultaLemit) ||
        this.parseDataLemit(consulta.dados?.data_consulta)
      )
    },

    parseDataLemit(valor) {
      if (!valor) return null

      const texto = String(valor).trim()
      const brMatch = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
      if (brMatch) {
        const [, day, month, year] = brMatch
        const data = new Date(Number(year), Number(month) - 1, Number(day))
        return Number.isNaN(data.getTime()) ? null : data
      }

      const data = new Date(texto)
      return Number.isNaN(data.getTime()) ? null : data
    },

    isDiaAnterior(data) {
      if (!data) return false

      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0)

      const referencia = new Date(data)
      referencia.setHours(0, 0, 0, 0)

      return referencia.getTime() < hoje.getTime()
    },
  },
}
</script>

<style scoped>
.client-feature-block {
  background: linear-gradient(135deg, #f8fbff 0%, #f3f7ff 100%);
  border: 1px solid rgba(70, 130, 180, 0.18);
  border-radius: 10px;
  padding: 12px 12px 4px;
}

.feature-action-btn {
  letter-spacing: 0.3px;
  box-shadow: 0 2px 8px rgba(70, 130, 180, 0.35) !important;
}

.feature-novo-chip {
  font-weight: 700;
  height: 20px;
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #355c7d;
  margin: 8px 0 10px;
}

.label-cell {
  width: 140px;
  font-weight: 600;
  color: #546e7a;
}
</style>
